var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.context.classes.groupAddMore},[_c('FormulateInput',{attrs:{"type":"button","label":_vm.context.addLabel,"data-minor":"","data-ghost":""},on:{"click":_vm.addMore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }